document.addEventListener('DOMContentLoaded', function () {
  var root = document.getElementById('savvy-madres-landing');
  if (!root) return;

  var answers = {};
  var currentQuestion = 0;

  var perfiles = {
    p1: {
      perfil: 'La mamá que aguanta todo',
      title: 'Tu sistema nervioso lleva tiempo en modo alerta.',
      desc: 'Resuelves, organizas, sostienes. Y sigues. Pero el cuerpo que sostiene a todos necesita que alguien también lo sostenga a él.',
      ciencia: 'El sistema nervioso autónomo lleva tiempo en modo simpático sin pasar al modo de reparación. Eso altera el descanso y la capacidad de recuperación.',
      productos: [
        { nombre: 'Renew', desc: 'Soporte para descanso y recuperación del sistema nervioso.' },
        { nombre: 'Great Day', desc: 'Apoyo para energía y demanda diaria.' },
        { nombre: 'GüdGut', desc: 'Soporte digestivo y bienestar general.' }
      ]
    },
    p2: {
      perfil: 'La mamá activa',
      title: 'Tu cuerpo quiere rendir más. Solo necesita lo correcto.',
      desc: 'El movimiento ya está en tu vida. Lo que falta es la materia prima para convertir ese esfuerzo en resultados.',
      ciencia: 'Cuando te mueves más, tu recuperación y tus reservas importan más. La nutrición adecuada hace la diferencia.',
      productos: [
        { nombre: 'Saturno', desc: 'Apoyo para fuerza y rendimiento.' },
        { nombre: 'Bone Broth Power Protein', desc: 'Soporte proteico para recuperación.' },
        { nombre: 'Recharge', desc: 'Reposición para acompañar la actividad.' }
      ]
    },
    p3: {
      perfil: 'La mamá hormonal',
      title: 'Tu cuerpo está en transición. No está roto.',
      desc: 'Los cambios de humor, el peso y los ciclos pueden ser señales de un desbalance que merece atención.',
      ciencia: 'El equilibrio hormonal depende de muchos sistemas conectados entre sí. La nutrición puede acompañar ese proceso.',
      productos: [
        { nombre: 'InnerBloom', desc: 'Apoyo para balance femenino.' },
        { nombre: 'Renew', desc: 'Soporte diario para recuperación.' },
        { nombre: 'Great Day', desc: 'Apoyo integral para energía y bienestar.' }
      ]
    },
    p4: {
      perfil: 'La mamá en recuperación',
      title: 'Tu cuerpo necesita reconstruirse.',
      desc: 'Después del embarazo o la lactancia, el cuerpo puede sentirse drenado y pedir reposición.',
      ciencia: 'La recuperación estructural y nutricional toma tiempo. El cuerpo necesita soporte constante.',
      productos: [
        { nombre: 'MultiCollagen', desc: 'Soporte para piel, pelo y articulaciones.' },
        { nombre: 'InnerBloom', desc: 'Apoyo para reequilibrio.' },
        { nombre: 'Bone Broth Power Protein', desc: 'Proteína para recuperación.' }
      ]
    },
    p5: {
      perfil: 'La mamá que cuida a todos',
      title: 'Un cuerpo que no se repone no puede seguir dando.',
      desc: 'Has sostenido demasiado por demasiado tiempo. Tu cuerpo necesita atención real.',
      ciencia: 'El desgaste acumulado afecta energía, inmunidad y bienestar general.',
      productos: [
        { nombre: 'DfsMix', desc: 'Apoyo para defensa y recuperación.' },
        { nombre: 'Veggie Powder', desc: 'Refuerzo nutricional diario.' },
        { nombre: 'Renew', desc: 'Apoyo para descanso y recuperación.' }
      ]
    },
    p6: {
      perfil: 'La mamá que quiere recuperar su fuerza',
      title: 'La fuerza también es salud.',
      desc: 'Recuperar músculo, resistencia y confianza es parte de sentirte bien otra vez.',
      ciencia: 'La masa muscular, la movilidad y la constancia importan más de lo que parece.',
      productos: [
        { nombre: 'Saturno', desc: 'Apoyo para fuerza y rendimiento.' },
        { nombre: 'Bone Broth Power Protein', desc: 'Proteína para sostener recuperación.' },
        { nombre: 'InnerBloom', desc: 'Apoyo complementario para bienestar integral.' }
      ]
    }
  };

  var questionWraps = root.querySelectorAll('.question-wrap');
  var testContainer = document.getElementById('savvy-test-container');
  var leadGate = document.getElementById('savvy-lead-gate');
  var resultado = document.getElementById('savvy-resultado');
  var progressNum = document.getElementById('savvy-progress-num');
  var progressFill = document.getElementById('savvy-progress-fill');
  var startBtn = document.getElementById('savvy-start-btn');
  var openGateBtn = document.getElementById('savvy-open-gate');
  var backToTestBtn = document.getElementById('savvy-back-to-test');
  var restartBtn = document.getElementById('savvy-restart');
  var form = document.getElementById('savvy-contact-form');
  var formStatus = document.getElementById('savvy-form-status');
  var submitBtn = document.getElementById('savvy-submit-btn');
  var contactBody = document.getElementById('savvy-contact-body');

  function updateProgress(index) {
    progressNum.textContent = (index + 1) + ' / 8';
    progressFill.style.width = (((index + 1) / 8) * 100) + '%';
  }

  function showQuestion(index) {
    currentQuestion = index;
    questionWraps.forEach(function (wrap, i) {
      wrap.style.display = i === index ? 'block' : 'none';
      wrap.classList.toggle('active', i === index);
    });
    updateProgress(index);
  }

  function getVoteProfile() {
    var votes = { p1: 0, p2: 0, p3: 0, p4: 0, p5: 0, p6: 0 };

    Object.keys(answers).forEach(function (key) {
      var value = answers[key];
      if (typeof value === 'string' && value.indexOf('p') === 0) {
        votes[value] += 1;
      }
    });

    var top = 'p1';
    var max = 0;

    Object.keys(votes).forEach(function (key) {
      if (votes[key] > max) {
        max = votes[key];
        top = key;
      }
    });

    return top;
  }

  function renderResult() {
    var perfilKey = getVoteProfile();
    var data = perfiles[perfilKey];
    if (!data) return;

    document.getElementById('savvy-r-perfil').textContent = data.perfil;
    document.getElementById('savvy-r-title').textContent = data.title;
    document.getElementById('savvy-r-desc').textContent = data.desc;
    document.getElementById('savvy-r-ciencia').textContent = data.ciencia;

    var productos = document.getElementById('savvy-r-productos');
    productos.innerHTML = '';

    data.productos.forEach(function (item) {
      var html = ''
        + '<div class="producto-item">'
        + '<div class="producto-dot"></div>'
        + '<div class="producto-info">'
        + '<h4>' + item.nombre + '</h4>'
        + '<p>' + item.desc + '</p>'
        + '</div>'
        + '</div>';
      productos.insertAdjacentHTML('beforeend', html);
    });
  }

  function openLeadGate() {
    testContainer.style.display = 'none';
    resultado.style.display = 'none';
    leadGate.style.display = 'block';
    document.getElementById('savvy-test').scrollIntoView({ behavior: 'smooth' });
  }

  function showResult() {
    renderResult();
    testContainer.style.display = 'none';
    leadGate.style.display = 'none';
    resultado.style.display = 'block';
    document.getElementById('savvy-test').scrollIntoView({ behavior: 'smooth' });
  }

  function resetTest() {
    answers = {};
    form.reset();
    formStatus.style.display = 'none';
    formStatus.className = '';
    formStatus.innerHTML = '';

    root.querySelectorAll('.option-btn').forEach(function (btn) {
      btn.classList.remove('selected');
    });

    root.querySelectorAll('.btn-next').forEach(function (btn, idx) {
      if (idx === 7) {
        btn.classList.add('enabled');
        btn.style.pointerEvents = 'none';
        btn.style.opacity = '0.35';
      } else {
        btn.classList.remove('enabled');
      }
    });

    resultado.style.display = 'none';
    leadGate.style.display = 'none';
    testContainer.style.display = 'block';
    showQuestion(0);
  }

  root.querySelectorAll('.question-wrap').forEach(function (wrap, qIndex) {
    var options = wrap.querySelectorAll('.option-btn');
    var nextBtn = wrap.querySelector('.btn-next');
    var backBtn = wrap.querySelector('.btn-back');

    options.forEach(function (btn) {
      btn.addEventListener('click', function () {
        options.forEach(function (b) { b.classList.remove('selected'); });
        btn.classList.add('selected');
        answers[qIndex] = btn.getAttribute('data-value');

        if (nextBtn) {
          nextBtn.classList.add('enabled');
        }
      });
    });

    if (nextBtn && qIndex < 7) {
      nextBtn.addEventListener('click', function () {
        if (!nextBtn.classList.contains('enabled')) return;
        showQuestion(qIndex + 1);
      });
    }

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        showQuestion(qIndex - 1);
      });
    }
  });

  openGateBtn.addEventListener('click', function () {
    if (!answers[7] && answers[7] !== '0') return;
    openLeadGate();
  });

  backToTestBtn.addEventListener('click', function () {
    leadGate.style.display = 'none';
    testContainer.style.display = 'block';
    showQuestion(7);
  });

  restartBtn.addEventListener('click', function () {
    resetTest();
  });

  startBtn.addEventListener('click', function () {
    document.getElementById('savvy-test').scrollIntoView({ behavior: 'smooth' });
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    var firstName = document.getElementById('savvy-first-name').value.trim();
    var lastName = document.getElementById('savvy-last-name').value.trim();
    var email = document.getElementById('savvy-email').value.trim();

    contactBody.value =
      'Lead capturado desde el test de Savvy.\n'
      + 'Nombre: ' + firstName + ' ' + lastName + '\n'
      + 'Correo: ' + email + '\n'
      + 'Fuente: savvy_test_madres';

    submitBtn.disabled = true;
    submitBtn.textContent = 'Enviando...';
    formStatus.style.display = 'none';
    formStatus.className = '';
    formStatus.innerHTML = '';

    var formData = new FormData(form);
    var params = new URLSearchParams();

    formData.forEach(function (value, key) {
      params.append(key, value);
    });

    fetch('/contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Accept': 'text/html'
      },
      body: params.toString()
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Error de envío');
        return response.text();
      })
      .then(function () {
        formStatus.style.display = 'block';
        formStatus.className = 'savvy-form-message';
        formStatus.innerHTML = 'Gracias. Tus datos fueron enviados correctamente.';
        showResult();
      })
      .catch(function () {
        formStatus.style.display = 'block';
        formStatus.className = 'savvy-form-errors';
        formStatus.innerHTML = 'Hubo un problema enviando el formulario. Inténtalo de nuevo.';
      })
      .finally(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Ver mi resultado';
      });
  });

  showQuestion(0);
});